import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { selectService } from '../../../store/service/service.selectors';
import { ServiceService } from '../../../../../services/service.service';
import { ServiceSettingsGqlService } from '../../../../../services/service-settings.gql-service';
import {
    ServiceWorkgroupGridObject,
} from '@libs/types/src/services/object-type/service/settings/service-workgroup.object';
import {
    ServiceOperationalCapacityGridObject,
} from '@libs/types/src/services/object-type/service/settings/service-operational-capacity.object';
import {
    ServiceWaitingListGridObject,
} from '@libs/types/src/services/object-type/service/settings/service-waiting-list.object';

interface State {
    serviceWorkgroups: ServiceWorkgroupGridObject | null,
    serviceOperationalCapacities: ServiceOperationalCapacityGridObject | null,
    serviceWaitingListItems: ServiceWaitingListGridObject | null,
}

const defaultState: State = {
    serviceWorkgroups: null,
    serviceOperationalCapacities: null,
    serviceWaitingListItems: null,
};

@Injectable()
export class ServicesSettingsGeneralInfoPageStore extends ComponentStoreFactory<State> {

    public service = this.globalStore!.selectSignal(selectService);
    constructor() {
        super(defaultState, inject(Store), inject(ServiceService), inject(ServiceSettingsGqlService));
    }
}
